import React from 'react';

/**
 * LogoMark - ClearEqual brand symbol.
 *
 * A magnifying glass with an equality sign inside the lens.
 * The equals sign is highlighted in the accent color to symbolize
 * the brand promise: searching for, surfacing, equal pay.
 *
 * Renders as inline SVG with transparent background.
 *
 * Props:
 *   color: stroke color for the magnifying glass (default navy)
 *   equalsColor: color of the equals sign (default gold)
 *   bgColor: lens fill (default transparent)
 *   size: pixel size for both width and height (default 32)
 *   className: optional Tailwind/CSS classes
 */
const LogoMark = ({
  color = '#0F172A',
  equalsColor = '#F4A43A',
  bgColor = 'transparent',
  size = 32,
  className = '',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-label="ClearEqual logo"
      role="img"
      {...props}
    >
      <circle cx="26" cy="26" r="18" fill={bgColor} stroke={color} strokeWidth="4.5" />
      <line x1="17" y1="22" x2="35" y2="22" stroke={equalsColor} strokeWidth="4" strokeLinecap="round" />
      <line x1="17" y1="30" x2="35" y2="30" stroke={equalsColor} strokeWidth="4" strokeLinecap="round" />
      <line x1="40" y1="40" x2="56" y2="56" stroke={color} strokeWidth="6" strokeLinecap="round" />
    </svg>
  );
};

export default LogoMark;
